export interface IChangePasswordState {
    newPassword: string;
    loading: boolean;
    authenticated: boolean;
    changeFail: boolean;
    changeSuccess: boolean;
    changeFailText: string;
    changeSuccessText: string;
    fromInvitation: any;
}

export const initialChangePasswordState: IChangePasswordState = {
    newPassword: null,
    loading: false,
    authenticated: false,
    changeFail: false,
    changeSuccess: false,
    changeFailText: '',
    changeSuccessText: '',
    fromInvitation: null
};
